import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function DiscoverThePerfectName() {
  const alphabetGrid = Array.from({
    length: 20
  }, (_, i) => String.fromCharCode(65 + i));
  return <section id="discover-the-perfect-name" className="bg-background py-16 md:py-24 lg:py-32 overflow-hidden relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          
          {}
          <div className="w-full lg:w-[60%] space-y-8 md:space-y-10">
            <div className="space-y-6">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-primary tracking-tight leading-[1.1]">
                Discover the Perfect Name
              </h1>
              <p className="text-lg md:text-xl text-foreground max-w-2xl leading-relaxed font-sans">
                Embark on the beautiful journey of naming. Explore our meticulously curated, alphabetically organized collections to find a name that resonates with meaning, style, and love for your little one. Welcome to a modern, sophisticated approach to finding the one.
              </p>
            </div>
            
            <div>
              <Button asChild size="lg" className="bg-secondary text-secondary-foreground hover:bg-accent hover:text-accent-foreground rounded-none h-16 px-10 text-lg font-semibold transition-colors duration-300 shadow-sm">
                <Link to="/BoyNamesPage">
                  Browse the Directory
                  <ArrowRight className="ml-3 size-6" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="w-full lg:w-[40%] relative mt-12 lg:mt-0">
            {}
            <div className="absolute -inset-12 md:-inset-16 grid grid-cols-4 gap-2 md:gap-4 opacity-10 z-0 pointer-events-none select-none overflow-hidden" aria-hidden="true">
              {alphabetGrid.map((letter, i) => <div key={letter} data-index={i} className="text-6xl md:text-8xl lg:text-9xl font-bold text-primary flex items-center justify-center font-serif">
                  {letter}
                </div>)}
            </div>

            {}
            <div className="relative z-10 bg-card p-2 shadow-xl">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577387/img/modern_nursery_detail.png" alt="Modern, stylish nursery interior detail with natural light" className="w-full h-[400px] md:h-[500px] lg:h-[600px] object-cover block" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}